<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-format-list-numbered-rtl" icon-small :title="reportTitle ? reportTitle : 'گزارش وام های اعضا بر اساس تاریخ'" color="accent" :loading="loading">
			<v-row>
				<v-col cols="12" style="padding:0 40px 40px">
					<v-row>
						<v-col cols="12" md="3">
						</v-col>
						<v-col cols="12" md="6">
							<date-navigator v-if="!hideDateRange" v-model="dateRange" :options="{ rangeMode: true }" />
						</v-col>
						<v-col cols="12" md="3" class="d-flex align-center justify-end">
							<v-btn v-if="!hideDateRange" color="primary" dark class="mx-1" @click="loadData">
								دریافت اطلاعات
							</v-btn>
							<export-excel :items="filteredItems" :headers="headers" :fileName="excelFileName">
							</export-excel>
						</v-col>
					</v-row>
					<v-row style="background-color: #eee;border: 1px solid #ddd;text-align: center;">
						<v-col cols="6" md="3" class="text-center">
							<div>تعداد:</div>
							<div class="grey--text">{{ loansCount }}</div>
						</v-col>
						<v-col cols="6" md="3" class="text-center">
							<div>خالص وام:</div>
							<div class="grey--text">{{ pureTotal.toString().toPriceFormat() }}</div>
						</v-col>
						<v-col cols="6" md="3" class="text-center">
							<div>با احتساب بهره:</div>
							<div class="grey--text">{{ profitTotal.toString().toPriceFormat() }}</div>
						</v-col>
						<v-col cols="6" md="3" class="text-center">
							<div>وصول نشده:</div>
							<div class="grey--text">{{ unpaidTotal.toString().toPriceFormat() }}</div>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12" v-if="loanTypes.length">
							<span class="ml-2">فیلتر نوع وام:</span>
							<v-btn-toggle v-model="loanTypeFilter" dense tile outlined color="purple" class="mr-2 flex-wrap">
								<v-btn v-for="loanType in loanTypes" :key="loanType.id" :value="loanType.id" small>
									{{ loanType.title }}
									<v-badge color="blue" :content="loanType.id === 'همه' ? items.length : items.filter(x => x.loanId == loanType.id).length || '0'" inline>
									</v-badge>
								</v-btn>
							</v-btn-toggle>
						</v-col>
						<v-col cols="12" md="8">
							<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
						</v-col>
						<v-col cols="12" md="4">
							<v-text-field v-model="search2" @change="searchLoan" append-icon="mdi-magnify" label="جستجوی شماره وام" single-line hide-details class="mb-5" />
						</v-col>
						<v-col cols="12">
							<v-data-table :height="dataTableFixedHeight - 100" fixed-header :headers="headers" :items="filteredItems" :footer-props="{ 'items-per-page-options': [5, 15, 50, 100] }" :items-per-page="50" :search="search" class="elevation-1">
								<template v-slot:item="row">
									<tr>
										<td>
											<div @click="manageLoans(row.item)" style="cursor:pointer">
												<div class="info--text"><small>کد: {{ row.item.code }}</small></div>
												<div class="grey--text"><small>{{ row.item.title }}</small></div>
											</div>
										</td>
										<td>
											<div @click="manageLoans(row.item)" style="cursor:pointer">
												<div><small>{{ row.item.fullName }}</small></div>
												<div><small>{{ row.item.mobile }}</small></div>
												<div><small>کد ملی: {{ row.item.nationalCode }}</small></div>
											</div>
										</td>
										<td class="text-right">
											<small>{{ row.item.agentBusinessName }}</small>
										</td>
										<td class="text-center">
											{{ row.item.amount.toString().toPriceFormat() }}
											<div class="success--text">{{ (row.item.month * row.item.installment).toString().toPriceFormat() }}
											</div>
										</td>
										<td class="text-center">
											{{ row.item.month }}
										</td>
										<td class="text-center">
											{{ row.item.startDate }}
										</td>
										<td class="text-center">
											{{ row.item.isCheckouted ? 'بلی' : 'خیر' }}
											<div class="grey--text" v-if="row.item.isCheckouted">{{ row.item.checkoutDate }}</div>
										</td>
										<td class="text-center">
											{{ row.item.paid.toString().toPriceFormat() }}
											<div class="grey--text text-small" v-if="row.item.paidCount > 0">{{ row.item.paidCount }} قسط</div>
										</td>
										<td class="text-center">
											{{ row.item.remain.toString().toPriceFormat() }}
											<div class="grey--text text-small" v-if="row.item.unpaidCount > 0">{{ row.item.unpaidCount }} قسط
											</div>
										</td>
										<td class="text-center">
											<div v-if="row.item.delays != 0">
												{{ row.item.delays > 0 ? 'دیرکرد' : 'زودکرد' }}: {{
													Math.abs(row.item.delays).toString().toPriceFormat() }}
											</div>
										</td>
									</tr>
								</template>
							</v-data-table>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</material-card>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />
		<v-dialog v-model="dialogLoansManager" scrollable max-width="1200px">
			<v-card>
				<v-card-title>
					<div><span class="headline">مدیریت وام</span></div>
					<v-spacer />
					<v-btn @click="dialogLoansManager = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<manage-loan ref="manageLoan" v-if="dialogLoansManager" :data="{ member: selectedMember }" />
				</v-card-text>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import ManageLoan from '@/views/admin/ManageLoan.vue'
	import toast from '@/util/toast'
	import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

	export default {
		name: 'CheckoutThisMonth',
		props: {
			autoSubmit: { type: Boolean, default: false },
			hideDateRange: { type: Boolean, default: false },
			filterOnlyCheckout: { type: Boolean, default: false },
			reportTitle: { type: String, default: '' },
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			'date-navigator': () => import('@/components/DateNavigator'),
			// 'manage-loan': import('@/views/admin/ManageLoan.vue'),
			ManageLoan,
			'date-picker': VuePersianDatetimePicker,
		},
		data() {
			return {
				search2: '',
				loanCodeFilter: '',
				dialogLoansManager: false,
				selectedMember: {},
				errorMessages: '',
				startDate: '',
				startDateValidatioin: '',
				endDateValidatioin: '',
				endDate: '',
				search: '',
				loading: false,
				headers: [
					{
						text: 'وام',
						align: 'center',
						sortable: true,
						value: 'code',
						width: '170'
					}, {
						text: 'مشتری',
						align: 'start',
						sortable: true,
						value: 'fullName',
						width: '150'
					}, {
						text: 'کد ملی',
						align: ' d-none',
						sortable: true,
						value: 'nationalCode',
					}, {
						text: 'موبایل',
						align: ' d-none',
						sortable: true,
						value: 'mobile',
					}, {
						text: 'نماینده',
						align: 'right',
						sortable: true,
						value: 'agentBusinessName',
						width: '150'
					}, {
						text: 'وام',
						align: ' d-none',
						sortable: true,
						value: 'title',
					}, {
						text: 'مبلغ',
						align: 'center',
						sortable: true,
						value: 'amount',
						excel_value: '%root%',
						excel_callback: (value) => {
							let text = `${value.amount}\n`
							text += (value.month * value.installment).toString()
							return text
						}
					}, {
						text: 'تعداد اقساط',
						align: 'center',
						sortable: true,
						value: 'month',
					}, {
						text: 'تاریخ شروع',
						align: 'center',
						sortable: true,
						value: 'startDate',
					}, {
						text: 'تسویه',
						align: 'center',
						sortable: true,
						value: 'isCheckouted',
						excel_value: '%root%',
						excel_callback: (value) => {
							let text = value.isCheckouted ? 'بلی' : 'خیر'
							if (value.isCheckouted)
								text += '\n' + value.checkoutDate
							return text
						}
					}, {
						text: 'پرداخت شده',
						align: 'center',
						sortable: true,
						value: 'paid',
						excel_value: '%root%',
						excel_callback: (value) => {
							let text = value.paid
							if (value.paidCount > 0)
								text += `\n ${value.paidCount} قسط`
							return text
						}
					}, {
						text: 'مانده',
						align: 'center',
						sortable: true,
						value: 'remain',
						excel_value: '%root%',
						excel_callback: (value) => {
							let text = value.remain
							if (value.unpaidCount > 0)
								text += `\n ${value.unpaidCount} قسط`
							return text
						}
					}, {
						text: 'تاخیر',
						align: 'center',
						sortable: true,
						value: 'delays',
						excel_callback: (value) => {
							let text = ''
							if (value != 0)
								text += `${value > 0 ? 'دیرکرد' : 'زودکرد'}:  ${Math.abs(value).toString()}`
							return text
						}
					}, {
						text: 'تعداد باقیمانده',
						align: 'center d-none',
						sortable: true,
						value: 'unpaidCount',
					},
				],
				items: [],
				dateRange: { start: new Date(new Date().setMonth(new Date().getMonth() - 1)).toJSON(), end: '' },
				loanTypes: [],
				loanTypeFilter: 'همه',
			}
		},
		computed: {
			loansCount() {
				return this.items.length
			},
			unpaidTotal() {
				return this.profitTotal - this.items.reduce((accumulator, current) => accumulator + current.paid, 0)
			},
			profitTotal() {
				return this.items.reduce((accumulator, current) => accumulator + (current.month * current.installment), 0)
			},
			pureTotal() {
				return this.items.reduce((accumulator, current) => accumulator + current.amount, 0)
			},
			excelFileName() {
				let name = 'گزارش وام اعضا'
				if (this.startDate)
					name += ' از ' + this.startDate.toString().split('T')[0]
				if (this.endDate)
					name += ' تا ' + this.endDate.toString().split('T')[0]
				name += '.xls'
				return name
			},
			filteredItems() {
				if (!this.loanTypeFilter)
					return this.items

				let clonedItems = []
				clonedItems.push(...this.items)

				if (this.loanTypeFilter !== 'همه')
					clonedItems = clonedItems.filter(x => x.loanId === this.loanTypeFilter)

				if (this.loanCodeFilter)
					clonedItems = clonedItems.filter(x => x.code == this.loanCodeFilter)

				return clonedItems
			}
		},
		created() {
			if (this.autoSubmit) {
				this.dateNavigatorOptions = { rangeMode: true, defaultEmpty: true }
			}
		},
		mounted() {
			console.log('filterOnlyCheckout', this.filterOnlyCheckout)
			if (this.autoSubmit) {
				this.loadData()
			}
		},
		methods: {
			manageLoans(item) {
				this.selectedMember = { id: item.memberId, fullName: item.fullName, nationalCode: item.nationalCode, mobile: item.mobile, userName: item.userName }
				this.dialogLoansManager = true

			},
			loadData() {
				this.loading = true
				api.get('admin/report/MemberLoansByDate/?start=' + this.dateRange.start + '&end=' + this.dateRange.end + '&isCheckout=' + this.filterOnlyCheckout, {})
					.then(
						response => {
							this.items = response
							this.loanTypes = Object.values(
								response.reduce((acc, obj) => ({ ...acc, [obj.loanId]: { id: obj.loanId, title: obj.title } }), {})
							)
							if (this.loanTypes.length) {
								this.loanTypes.push({ id: 'همه', title: 'همه' })
							}
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.loading = false })
			},
			searchLoan() {
				this.loanCodeFilter = this.search2
			}
		},
	}
</script>
<style></style>
